import { useState, useCallback } from "react";
import { Transaction, TransactionCategory } from "../../types/budgethelper";

interface UseTransactionFormProps {
  userProfileUserId: string;
  defaultBudgetGroup: string;
}

export const useTransactionForm = ({ userProfileUserId, defaultBudgetGroup }: UseTransactionFormProps) => {
  const [editingTransaction, setEditingTransaction] = useState<Transaction | null>(null);
  const [shopName, setShopName] = useState("");
  const [transactionAmount, setTransactionAmount] = useState("");
  const [paidBy, setPaidBy] = useState(userProfileUserId);
  const [selectedCategory, setSelectedCategory] = useState<TransactionCategory>(TransactionCategory.OTHER);
  const [selectedBudgetGroupId, setSelectedBudgetGroupId] = useState(defaultBudgetGroup);
  const [splitAmounts, setSplitAmounts] = useState<{ [userId: string]: number | string }>({});

  const resetForm = useCallback(() => {
    setShopName("");
    setTransactionAmount("");
    setSelectedCategory(TransactionCategory.OTHER);
    setSelectedBudgetGroupId(defaultBudgetGroup);
    setPaidBy(userProfileUserId);
    setSplitAmounts({});
    setEditingTransaction(null);
  }, [userProfileUserId, defaultBudgetGroup]);

  const loadTransaction = useCallback((transaction: Transaction) => {
    setEditingTransaction(transaction);
    setTransactionAmount(transaction.amount.toFixed(2));
    setPaidBy(transaction.paidBy || userProfileUserId);
    setSelectedCategory((transaction.category || TransactionCategory.OTHER) as TransactionCategory);
    setSelectedBudgetGroupId(transaction.budgetGroup || defaultBudgetGroup);
    setShopName(transaction.shopName);
    
    const splits = transaction.splitAmounts && Object.keys(transaction.splitAmounts).length > 0
      ? transaction.splitAmounts
      : { [transaction.paidBy || userProfileUserId]: transaction.amount };
    
    setSplitAmounts(splits);
  }, [userProfileUserId, defaultBudgetGroup]);

  return {
    editingTransaction,
    shopName,
    setShopName,
    transactionAmount,
    setTransactionAmount,
    paidBy,
    setPaidBy,
    selectedCategory,
    setSelectedCategory,
    selectedBudgetGroupId,
    setSelectedBudgetGroupId,
    splitAmounts,
    setSplitAmounts,
    resetForm,
    loadTransaction,
  };
};
